import "../../styles/securityBadge.css"
function SecurityBadge({ securityScore }) {
   return <span className={`inline-block w-[6px] mt-2 mb-2 h-5 mr-2 rounded-[4px] ${mapSecurityScoreToBadge(securityScore)}`}></span>
}

const mapSecurityScoreToBadge = (securityScore) => {

    if(securityScore <= 30) {
        return "badge-high-risk"
    } else if (securityScore <= 60) {
        return "badge-moderate-risk"
    } else if (securityScore <= 95) {
        return "badge-low-moderate-risk"
    } else {
        return "badge-low-risk"
    }
}

export default SecurityBadge